import { render, staticRenderFns } from "./ProfileCarousel.vue?vue&type=template&id=2e2d56ae&scoped=true&"
import script from "./ProfileCarousel.vue?vue&type=script&lang=ts&"
export * from "./ProfileCarousel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2d56ae",
  null
  
)

export default component.exports